import { BookingRefundPolicy } from '@/models/license'

export const REFUND_POLICY_DAYS_MAP: Record<BookingRefundPolicy, number> = {
  [BookingRefundPolicy.TWO_DAYS]: 2,
  [BookingRefundPolicy.FIVE_DAYS]: 5,
  [BookingRefundPolicy.SIX_DAYS]: 6,
  [BookingRefundPolicy.SEVEN_DAYS]: 7,
  [BookingRefundPolicy.TEN_DAYS]: 10,
  [BookingRefundPolicy.FOURTEEN_DAYS]: 14,
  [BookingRefundPolicy.FIFTEEN_DAYS]: 15,
  [BookingRefundPolicy.DAY_BEFORE]: 1,
  [BookingRefundPolicy.NEVER]: 0,
}
